import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  TextTitle,
  ValidatedPanel,
  getPanelErrorProps,
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { ImageListPortalContainerWithControlErrorHandling } from './image-list-portal-container';
import { ImageListSummaryCardDetails } from './image-list-card-details';
import ImageAssetsImg from '../media/image-assets.svg';

export const ImageListPortalContainerSection = ({
  expand,
  images,
  imageLimit,
  containerRef,
  containerState,
  classes,
  ...rest
}) => {
  const i18n = useContext(I18nContext);
  return (
    <ValidatedPanel
      key="images"
      title={<TextTitle
        titleKey={_TL_('Images')}
        topicKey="pop_BA_CampaignCreate_AudAds_Images"
        icon={ImageAssetsImg}
        iconAltText={i18n.getString(_TL_('"Images" panel\'s image'))}
        details={<ImageListSummaryCardDetails i18n={i18n} images={images} isLogos={false} />}
      />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
        expand,
        expandKey: 'images',
      }}
      {...rest}
    >
      <span>{i18n.getString(_TL_('You can add up to {{limit}} images to your ad.'), { limit: imageLimit })}</span>
      <div className={classes.imageExperienceStyle}>
        <ImageListPortalContainerWithControlErrorHandling
          i18n={i18n}
          containerRef={containerRef}
          containerState={containerState}
          isLogos={false}
        />
      </div>
    </ValidatedPanel>
  );
};

ImageListPortalContainerSection.propTypes = {
  expand: PropTypes.func.isRequired,
  images: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))).isRequired,
  imageLimit: PropTypes.number.isRequired,
  containerRef: PropTypes.shape({
    current: PropTypes.shape({}),
  }).isRequired,
  containerState: PropTypes.shape({}),
  classes: PropTypes.shape({
    imageExperienceStyle: PropTypes.string,
  }),
};

ImageListPortalContainerSection.defaultProps = {
  containerState: {},
  classes: {},
};
